export default __webpack_public_path__ + "static/media/game_01_intro_v2.44aa51e5.png";